export default __webpack_public_path__ + "static/media/hh-character-hello-positive-speaking.1477b6c4.mp4";